var customGameData = {
  "Green-Hollow": {
    gameType: "Shuffled",
    "gameTitle": "Green Hollow",
    "gameBlurb":
      "A tiny quest to change your village for the better, and explore real world teamwork at the same time.",
    "ogImage":
      "https://amble.studio/wp-content/uploads/2022/09/Green-Hollow-Rectangle-Story-Synth.png",
    sheetID: "1ghm-XOUZlYaOeHcl0zer4KSpCMaoN5u_X7iWmN2TrjY",
  },
    "Green-Hollow-Test": {
    gameType: "Shuffled",
    "gameTitle": "Green Hollow [TEST]",
    "gameBlurb":
      "A tiny quest to change your village for the better, and explore real world teamwork at the same time.",
    "ogImage":
      "https://amble.studio/wp-content/uploads/2022/09/Green-Hollow-Rectangle-Story-Synth.png",
    sheetID: "1hvNH35dVE-n-iYvjX5TEtK3yvZm7wcrVMruIJgw9roY",
  },
    "Office-Heroes": {
    gameType: "Shuffled",
    "gameTitle": "Office Heroes",
    "gameBlurb":
      "A funny, fast game of superheroes with wild office-based powers.",
    "ogImage":
      "https://amble.studio/wp-content/uploads/2022/09/Office-Heroes-Play.Amble_.png",
    sheetID: "1VEffJjBUA4OkWfG0qzifyqI2gMRTGr6RjFdyY_opQ3k",
  },
    "Office-Heroes-Test": {
    gameType: "Shuffled",
    "gameTitle": "Office Heroes [TEST]",
    "gameBlurb":
      "A funny, fast game of superheroes with wild office-based powers. [TEST VERSION]",
    "ogImage":
      "https://amble.studio/wp-content/uploads/2022/09/Office-Heroes-Play.Amble_.png",
    sheetID: "1uQItepleEFmBoh6TiASZQwHUxCQwz_PqrU6PWwh8M4Y",
  },
    "Tumbledown-Grove": {
    gameType: "Hexflower",
    "gameTitle": "Tumbledown Grove",
    "gameBlurb":
      "An interactive story about feelings that makes your child the main character of their own fantastic tale.",
    "ogImage":
      "https://amble.studio/wp-content/uploads/2022/09/Tumbledown-Grove-Play.Amble-logo.png",
    sheetID: "1CNS6ej3u2T5dcSSXX7dREoSTWLGp9oo1j0coyIATYXQ",
  },
    "Tumbledown-Grove-Test": {
    gameType: "Hexflower",
    "gameTitle": "Tumbledown Grove [TEST]",
    "gameBlurb":
      "An interactive story about feelings that makes your child the main character of their own fantastic tale.",
    "ogImage":
      "https://amble.studio/wp-content/uploads/2022/09/Tumbledown-Grove-Play.Amble-logo.png",
    sheetID: "1RXBhK6GRqNWEkYSK83IOjskdn-HUWbdiPkCA327ey60",
  },
    "Umberdred-Institute": {
    gameType: "Generator",
    "gameTitle": "Umberded Institute",
    "gameBlurb":
      "Tell silly stories about how aspiring villains accept unlikely quests to earn dubious certifications in evildoing skills.",
    "ogImage":
      "https://amble.studio/wp-content/uploads/2021/08/UmberdredTitle-1.png",
    sheetID: "1-yrqoN7ZKeLHg0ynob9ZCpUbr64T24IrpX1RuSFUAwY",
  },
    "Umberdred-Institute-Test": {
    gameType: "Generator",
    "gameTitle": "Umberded Institute [TEST]",
    "gameBlurb":
      "Tell silly stories about how aspiring villains accept unlikely quests to earn dubious certifications in evildoing skills. [TEST VERSION]",
    "ogImage":
      "https://amble.studio/wp-content/uploads/2021/08/UmberdredTitle-1.png",
    sheetID: "1loEjdT3ysVwHHy-_8f6slb4XSipOCi-Q_M_flkcx7Tw",
  },
    "Active-Town": {
    gameType: "Shuffled",
    "gameTitle": "Active Town",
    "gameBlurb":
      "A tiny quest to find your path and change your village for the better.",
    "ogImage":
      "https://amble.studio/wp-content/uploads/2022/12/Active-Town-Square.png",
    sheetID: "19WWgPzcXsIMA3f57r8zSezAwvB7_U5LJ67utKXX-NEs",
  },
}

export default customGameData